import { StateType } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { ToastReducer } from '../components/toast/presentation/store/reducer';
import { GetAllOfficeServersReducer } from '../features/officeServers/presentation/store/getAllOfficeServers/reducer';
import { CreateOfficeServerReducer } from '../features/officeServers/presentation/store/createOfficeServer/reducer';
import { UpdateOfficeServerReducer } from '../features/officeServers/presentation/store/updateOfficeServer/reducer';
import { GetServerAuditTrailReducer } from '../features/officeServers/presentation/store/getServerAuditTrail/reducer';
import { GetFinalityLogsReducer } from '../features/finalityLogs/presentation/store/getFinalityLogs/reducer';


const RootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),

    toast: ToastReducer,
    
    getAllOfficeServers: GetAllOfficeServersReducer,
    createOfficeServer: CreateOfficeServerReducer,
    updateOfficeServer: UpdateOfficeServerReducer,
    getServerAuditTrail: GetServerAuditTrailReducer,

    getFinalityLogs: GetFinalityLogsReducer,
  });

export default RootReducer;


export type AppState = StateType<ReturnType<typeof RootReducer>>;
